export const editProfile = {
  pageTitle: "プロフィール編集",
  sections: {
    account: "アカウント",
    introduction: "自己紹介",
    profile: "プロフィール",
    preferences: "好みの条件",
  },
  /**
   * 好みの条件（4問）。残りの8問はオンボーディングで聞く。
   * 並びは選択肢の番号どおりではないので、値への読み替えは usePreferenceConditions が持つ。
   */
  preferences: {
    minHLevel: "求めるHレベル",
    minHLevelOptions: ["こだわらない", "♥", "♥♥", "♥♥♥", "♥♥♥♥", "♥♥♥♥♥"],
    leadLevel: "リードしたいか",
    leadLevelOptions: [
      "自分がリードしたい",
      "どちらかといえば自分から",
      "どちらでもない",
      "どちらかといえば任せたい",
      "引っ張ってほしい",
    ],
    marriage: "婚姻",
    marriageOptions: ["未婚", "どっちも", "人妻"],
    speechStyle: "口調",
    speechStyleOptions: ["ギャル", "どっちも", "清楚"],
  },
  addImage: "プロフィール写真を追加",
  addMoreImage: "写真を追加",
  changeName: "名前を変更",
  age: "年齢",
  region: "地域",
  marriageHistory: "結婚歴",
  talkTheme: "通話内容の希望",
  hobby: "趣味",
  personality: "性格",
  bodyType: "体型",
  activeTime: "よくいる時間帯",
  occupation: "職業",
  preferredLooks: "好みのルックス",
  holiday: "休日",
  housemate: "同居人",
  bloodType: "血液型",
  alcohol: "お酒",
  smoking: "タバコ",
  save: "保存",
  cancel: "キャンセル",
  nameLabel: "ニックネーム",
  bioLabel: "自己紹介",
  noticeText: "全て登録して注目度UPしよう！",
  pointTarget: "ポイント対象",
} as const;
